import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Términos de Uso | CompresorJPEG"
        description="Términos y condiciones de uso de CompresorJPEG. Condiciones del servicio de compresión de imágenes online."
        keywords="terminos uso, condiciones servicio, terminos compresor imagenes"
        canonical="https://compresorjpeg.com/terminos"
      />
      <NavBar />

      <main className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-8">Términos de Uso</h1>
        <p className="text-sm text-muted-foreground mb-8">Última actualización: 17 de febrero de 2026</p>

        <div className="prose max-w-none space-y-6 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar CompresorJPEG (<a href="https://compresorjpeg.com" className="text-primary hover:underline">compresorjpeg.com</a>), 
              aceptas estos términos de uso. Si no estás de acuerdo, por favor no utilices el servicio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">2. Descripción del Servicio</h2>
            <p>CompresorJPEG ofrece:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Compresión de imágenes JPG, PNG, WebP y GIF</li>
              <li>Eliminación de fondo de imágenes con IA</li>
              <li>Redimensionamiento de imágenes</li>
              
            </ul>
            <p className="mt-2">
              Todo el procesamiento se realiza localmente en tu navegador. No almacenamos tus imágenes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">3. Plan Gratuito y Premium</h2>
            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">3.1 Plan Gratuito</h3>
            <p>El plan gratuito incluye acceso a la herramienta de compresión con límites de uso diario.</p>
            
            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">3.2 Plan Premium</h3>
            <p>
              El plan Premium ofrece funcionalidades adicionales mediante suscripción mensual o anual. 
              Los pagos se procesan a través de Stripe.
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Puedes cancelar tu suscripción en cualquier momento</li>
              <li>La cancelación es efectiva al final del período de facturación</li>
              <li>No ofrecemos reembolsos por períodos parciales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">4. Uso Aceptable</h2>
            <p>Te comprometes a:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>No usar el servicio para procesar contenido ilegal</li>
              <li>No intentar acceder a áreas restringidas del servicio</li>
              <li>No sobrecargar intencionalmente el servicio</li>
              <li>Respetar los derechos de propiedad intelectual de terceros</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">5. Propiedad Intelectual</h2>
            <p>
              <strong>Tus imágenes son tuyas.</strong> No reclamamos ningún derecho sobre las imágenes que procesas. 
              El código fuente, diseño y marca de CompresorJPEG son propiedad de sus creadores.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">6. Limitación de Responsabilidad</h2>
            <p>
              El servicio se proporciona "tal cual". No garantizamos que sea ininterrumpido o libre de errores. 
              No somos responsables de pérdida de datos o daños derivados del uso del servicio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">7. Modificaciones</h2>
            <p>
              Nos reservamos el derecho de modificar estos términos en cualquier momento. 
              Los cambios serán efectivos inmediatamente tras su publicación en esta página.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">8. Contacto</h2>
            <p>
              Para consultas sobre estos términos, puedes contactarnos a través de nuestro sitio web.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-border text-sm text-muted-foreground">
          <Link to="/" className="text-primary hover:underline">← Volver al compresor</Link>
          {" · "}
          <Link to="/privacidad" className="text-primary hover:underline">Política de Privacidad</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
